import React, { Component } from 'react';
import { connect } from 'react-redux';
import HelpPane from 'components/HelpPane/HelpPane';
import { closeHelpPane } from 'store/actions/helpPane';

class HelpPaneManager extends Component {
  render() {
    var isOpen = this.props.isOpen;
    var activeTopic = this.props.activeTopic;

    return React.createElement(React.Fragment, null,
      isOpen && React.createElement('div', {
        className: 'help-pane-overlay',
        onClick: this.props.closeHelpPane,
      }),
      React.createElement(HelpPane, {
        isOpen: isOpen,
        activeTopic: activeTopic,
        onClose: this.props.closeHelpPane,
      })
    );
  }
}

var mapStateToProps = function (state) {
  return {
    isOpen: state.helpPane.isOpen,
    activeTopic: state.helpPane.activeTopic,
  };
};

var mapDispatchToProps = {
  closeHelpPane: closeHelpPane,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpPaneManager);
